import { render, staticRenderFns } from "./TextSubtitle.vue?vue&type=template&id=5719bdb4"
import script from "./TextSubtitle.vue?vue&type=script&lang=js"
export * from "./TextSubtitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports